import { Card, CardContent } from '@/components/ui/card';
import { useLanguage } from '@/i18n/LanguageContext';
import { BehaviorCard } from '@/components/admin/analytics/BehaviorCard';

export const BuyerBehaviorCard = ({ buyerBehavior, paidOrders }) => {
  const { t } = useLanguage();
  return (
    <Card className="bg-card border-border mb-10" data-testid="buyer-behavior-card">
      <CardContent className="p-6">
        <h3 className="text-lg font-bold mb-1">{t('analytics.buyerBehaviorTitle')}</h3>
        <p className="text-sm text-muted-foreground mb-6">{t('analytics.buyerBehaviorDesc')}</p>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <BehaviorCard
            label={t('analytics.bundleBuyersLabel')}
            pct={buyerBehavior.bundle_pct}
            count={buyerBehavior.bundle_orders}
            total={paidOrders}
            accent="bg-amber-500"
          />
          <BehaviorCard
            label={t('analytics.printBuyersLabel')}
            pct={buyerBehavior.print_pct}
            count={buyerBehavior.print_orders}
            total={paidOrders}
            accent="bg-blue-500"
          />
          <BehaviorCard
            label={t('analytics.digitalOnlyBuyersLabel')}
            pct={buyerBehavior.digital_only_pct}
            count={buyerBehavior.digital_only_orders}
            total={paidOrders}
            accent="bg-primary"
          />
          <div className="bg-card border border-border rounded-sm p-4">
            <p className="text-xs text-muted-foreground mb-1">{t('analytics.alacarteDigitalLabel')}</p>
            <p className="text-2xl font-bold font-mono">{buyerBehavior.digital_photos_alacarte}</p>
            <p className="text-xs text-muted-foreground mt-2">{t('analytics.alacarteDigitalSub')}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
